import dayjs from 'dayjs'
import { t } from 'i18next'
import {UseFormReturn} from 'react-hook-form'
import {
	EducationReport,
	EducationReportDb,
	SubCompetenceAssessment
} from '../../../../../model/enums/educationReport.model'
import {Observation} from '../../../../../model/observation'
import {Person} from '../../../../../model/person.model'
import {findPersonById} from '../../../../../util/arraySearch'
import {sortByCreatedOn} from '../../../../../util/sortByCreatedOn'

export const defaultCompetences = [
	{
		sub_competence_assessment: [
			{
				id_sub_competence: 1,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 2,
				rating: 0,
				reason: ''
			}
			,
			{
				id_sub_competence: 3,
				rating: 0,
				reason: ''
			}
			,
			{
				id_sub_competence: 4,
				rating: 0,
				reason: ''
			}
		]
	},
	{
		sub_competence_assessment: [
			{
				id_sub_competence: 5,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 6,
				rating: 0,
				reason: ''
			}
			,
			{
				id_sub_competence: 7,
				rating: 0,
				reason: ''
			}
			,
			{
				id_sub_competence: 8,
				rating: 0,
				reason: ''
			}
		]
	},
	{
		sub_competence_assessment: [
			{
				id_sub_competence: 9,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 10,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 11,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 12,
				rating: 0,
				reason: ''
			}
		]
	},
	{
		sub_competence_assessment: [
			{
				id_sub_competence: 13,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 14,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 15,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 16,
				rating: 0,
				reason: ''
			}
		]
	},
	{
		sub_competence_assessment: [
			{
				id_sub_competence: 17,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 18,
				rating: 0,
				reason: ''
			}
		]
	},
	{
		sub_competence_assessment: [
			{
				id_sub_competence: 19,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 20,
				rating: 0,
				reason: ''
			},
			{
				id_sub_competence: 21,
				rating: 0,
				reason: ''
			}
		]
	}
]

export const defaultEducationReport: EducationReport = {
	education_report_id: 0,
	id_apprentice: 0,
	id_responsible: 0,
	closing_date: undefined,
	course_agreement: '',
	discussion_date: undefined,
	education_person_ct: 0,
	signed_file_reference: '',
	feedback_apprenticeship_by_apprentice: '',
	feedback_responsible_by_apprentice: '',
	miscellaneous: '',
	semester_report: 0,
	competence: [...defaultCompetences],
	submission_date: undefined,
	target_achievement_note: '',
	last_change: undefined,
	is_active: 1,
	observations: []
}

export function insertObservationsByCompetences(methods: UseFormReturn<EducationReport, object>, employees: Person[]) {
	return (
		competenceNumber: number,
		subCompetenceNumber: number,
		formIndex: number,
		observations: Observation[] | undefined
	) => {
		if (!observations) {
			return
		}

		const subComps = sortByCreatedOn(observations.filter(obs => obs.id_sub_competence === subCompetenceNumber))

		if (!subComps || subComps.length === 0) {
			return
		}
		const competenceIndex = competenceNumber - 1

		let reasonsString = methods.getValues(
			`competence.${competenceIndex}.sub_competence_assessment.${formIndex}.reason`
		)
		subComps?.forEach((obs: Observation) => {
			if (obs.reason) {
				const reporter = findPersonById(obs.id_reporter, employees)
				let initialsReporter: string
				if (reporter?.first_name) {
					initialsReporter = `(${
						reporter?.first_name?.substring(0, 1)}.${reporter?.last_name?.substring(0, 1)}.)`
				} else {
					initialsReporter = '(?) '
				}
				reasonsString += `${dayjs(obs.created_on).format(t<string>('locales.dateFormat'))} ${obs.reason} ${initialsReporter} `
			}
		})

		methods.setValue(`competence.${competenceIndex}.sub_competence_assessment.${formIndex}.reason`,
			reasonsString)
		// trigger validation for length
		methods.trigger()
		const totalObservationsForSubCompetence = subComps.length
		const existingRating = methods.getValues(
			`competence.${competenceIndex}.sub_competence_assessment.${formIndex}.rating`
		)

		if (existingRating) {
			console.log('[Education Report] Rating is already saved. not going to overwrite the rating.')
			return
		}
		if (totalObservationsForSubCompetence === 1) {


			methods.setValue(`competence.${competenceIndex}.sub_competence_assessment.${formIndex}.rating`,
				subComps[0].rating)
			return
		}

		let totalRating = 0
		subComps.forEach((obs: Observation) => {
			totalRating += obs.rating
		})

		if (totalRating > 0) {
			const average = Math.floor(totalRating / totalObservationsForSubCompetence)
			// console.log('Average Rating ' + subCompetenceNumber +' ' + average)
			methods.setValue(`competence.${competenceIndex}.sub_competence_assessment.${formIndex}.rating`,
				average)
		}
	}
}

export const insertObservationsIntoCompetence = (
	setHasUnsavedChanges: (
		value: (((prevState: boolean) => boolean) | boolean)
	) => void,
	insertObservationByComp: (
		competenceNumber: number,
		subCompetenceNumber: number,
		formIndex: number,
		observations: (Observation[] | undefined)
	) => void,
	methods: UseFormReturn<EducationReport, object>
) => {
	return (observations: Observation[] | undefined) => {
		if (!observations) {
			console.log('[Education Report] No observations found for selected apprentice and selected semester.')
			return
		}
		// get all observations which have not been used
		const unusedObservations = observations
			.filter(obs => obs.id_education_report === undefined || obs.id_education_report === null)

		if (unusedObservations.length === 0) {
			console.log('[Education Report] All observations of this apprentice have already been used, ' +
				'there is no observation which is not used for an education report.')
			return
		}
		setHasUnsavedChanges(true)
		insertObservationByComp(1, 1, 0, unusedObservations)
		insertObservationByComp(1, 2, 1, unusedObservations)
		insertObservationByComp(1, 3, 2, unusedObservations)
		insertObservationByComp(1, 4, 3, unusedObservations)
		insertObservationByComp(2, 5, 0, unusedObservations)
		insertObservationByComp(2, 6, 1, unusedObservations)
		insertObservationByComp(2, 7, 2, unusedObservations)
		insertObservationByComp(2, 8, 3, unusedObservations)
		insertObservationByComp(3, 9, 0, unusedObservations)
		insertObservationByComp(3, 10, 1, unusedObservations)
		insertObservationByComp(3, 11, 2, unusedObservations)
		insertObservationByComp(3, 12, 3, unusedObservations)
		insertObservationByComp(4, 13, 0, unusedObservations)
		insertObservationByComp(4, 14, 1, unusedObservations)
		insertObservationByComp(4, 15, 2, unusedObservations)
		insertObservationByComp(4, 16, 3, unusedObservations)
		insertObservationByComp(5, 17, 0, unusedObservations)
		insertObservationByComp(5, 18, 1, unusedObservations)
		insertObservationByComp(6, 19, 0, unusedObservations)
		insertObservationByComp(6, 20, 1, unusedObservations)
		insertObservationByComp(6, 21, 2, unusedObservations)

		const obsValues = methods.getValues('observations')
		let obsIds: number[] = []
		// if the observations are already filled we want to append new observations added
		if (obsValues && obsValues.length > 0) {
			obsIds = obsValues
		}

		// TODO use sth else than map
		// eslint-disable-next-line array-callback-return
		unusedObservations.map((o: Observation) => {
			if (o.observation_id) {
				obsIds.push(o.observation_id)
			}
		})
		return obsIds
	}
}

export const setSubCompetenceAssessment = (subCompAssessment: SubCompetenceAssessment,
	educationReportCopy: any,
	competenceIndex: number,
	subCompetenceAssessmentIndex: number) => {
	if (subCompAssessment.id_sub_competence
		=== educationReportCopy.competence[competenceIndex]
			.sub_competence_assessment[subCompetenceAssessmentIndex].id_sub_competence
	) {
		educationReportCopy.competence[competenceIndex]
			.sub_competence_assessment[subCompetenceAssessmentIndex].sub_competence_assessment_id
			= subCompAssessment.sub_competence_assessment_id
		educationReportCopy.competence[competenceIndex]
			.sub_competence_assessment[subCompetenceAssessmentIndex].reason
			= subCompAssessment.reason
		educationReportCopy.competence[competenceIndex]
			.sub_competence_assessment[subCompetenceAssessmentIndex].rating
			= subCompAssessment.rating
		educationReportCopy.competence[competenceIndex]
			.sub_competence_assessment[subCompetenceAssessmentIndex].last_change
			= subCompAssessment.last_change
		educationReportCopy.competence[competenceIndex]
			.sub_competence_assessment[subCompetenceAssessmentIndex].is_active
			= subCompAssessment.is_active
		educationReportCopy.competence[competenceIndex]
			.sub_competence_assessment[subCompetenceAssessmentIndex].id_education_report
			= subCompAssessment.id_education_report
	}
}


export const formatEducationReport = (eduReport: EducationReportDb): EducationReport => {

	if (!eduReport) {
		return JSON.parse(JSON.stringify(defaultEducationReport))
	}

	const deepNestedClone = JSON.parse(JSON.stringify(eduReport))
	const deepNestedCloneCompetences = JSON.parse(JSON.stringify(defaultCompetences))

	const educationReportCopy: any = {
		closing_date: deepNestedClone.closing_date,
		course_agreement: deepNestedClone.course_agreement,
		discussion_date: deepNestedClone.discussion_date,
		education_person_ct: deepNestedClone.education_person_ct,
		feedback_apprenticeship_by_apprentice: deepNestedClone.feedback_apprenticeship_by_apprentice,
		feedback_responsible_by_apprentice: deepNestedClone.feedback_responsible_by_apprentice,
		id_apprentice: deepNestedClone.id_apprentice,
		id_responsible: deepNestedClone.id_responsible,
		is_active: deepNestedClone.is_active,
		last_change: deepNestedClone.last_change,
		miscellaneous: deepNestedClone.miscellaneous,
		semester_report: deepNestedClone.semester_report,
		signed_file_reference: deepNestedClone.signed_file_reference,
		submission_date: deepNestedClone.submission_date,
		target_achievement_note: deepNestedClone.target_achievement_note,
		education_report_id: deepNestedClone.education_report_id,
		competence: deepNestedCloneCompetences,
		// create shallow copy of number array
		observations: deepNestedClone.observations
	}

	eduReport?.sub_competence_assessment?.forEach((subCompAssessment: SubCompetenceAssessment) => {
		for (let i = 0; i < 4; i++) {
			setSubCompetenceAssessment(subCompAssessment, educationReportCopy, 0, i)
			setSubCompetenceAssessment(subCompAssessment, educationReportCopy, 1, i)
			setSubCompetenceAssessment(subCompAssessment, educationReportCopy, 2, i)
			setSubCompetenceAssessment(subCompAssessment, educationReportCopy, 3, i)
		}
		for (let j = 0; j < 2; j++) {
			setSubCompetenceAssessment(subCompAssessment, educationReportCopy, 4, j)
		}
		for (let k = 0; k < 3; k++) {
			setSubCompetenceAssessment(subCompAssessment, educationReportCopy, 5, k)
		}
	})
	return educationReportCopy
}

export function resetExceptPersonsAndSemester(methods: UseFormReturn<EducationReport, object>, personId: number) {
	return () => {
		const eduId = methods.getValues('education_report_id')
		const apprenticeId = methods.getValues('id_apprentice')
		const tempRes = methods.getValues('id_responsible')
		const tempSem = methods.getValues('semester_report')
		console.log(
			`[Education Report] Resetting form except id_apprentice (${apprenticeId}), 
            id_responsible (${tempRes}) and semester (${tempSem})`
		)
		const temp = {...defaultEducationReport, ...defaultEducationReport.competence}

		temp.education_report_id = eduId
		temp.id_apprentice = apprenticeId
		// set responsible to editing person if it is not set
		temp.id_responsible = (!tempRes || tempRes < 1) ? personId : tempRes
		temp.semester_report = tempSem
		methods.reset(temp)
	}
}